/**
 * Generated by orval v6.29.0 🍺
 * Do not edit manually.
 * Cloudsaver.Export.Host.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from 'react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query'
import type {
  ExportRequest,
  ExportRequestJobJob,
  GetExportDownloadParams
} from './Export/model'
import { request } from '../Services/BasicApi';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const postExportExport = (
    exportRequest: ExportRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ExportRequestJobJob>(
      {url: `/Export/Export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportRequest
    },
      { type: 'Export',  ...options});
    }
  


export const getPostExportExportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExportExport>>, TError,{data: ExportRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postExportExport>>, TError,{data: ExportRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postExportExport>>, {data: ExportRequest}> = (props) => {
          const {data} = props ?? {};

          return  postExportExport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostExportExportMutationResult = NonNullable<Awaited<ReturnType<typeof postExportExport>>>
    export type PostExportExportMutationBody = ExportRequest
    export type PostExportExportMutationError = unknown

    export const usePostExportExport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExportExport>>, TError,{data: ExportRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postExportExport>>,
        TError,
        {data: ExportRequest},
        TContext
      > => {

      const mutationOptions = getPostExportExportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getExportDownload = (
    params?: GetExportDownloadParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Export/Download`, method: 'GET',
        params, signal
    },
      { type: 'Export',  ...options});
    }
  

export const getGetExportDownloadQueryKey = (params?: GetExportDownloadParams,) => {
    return [`/Export/Download`, ...(params ? [params]: [])] as const;
    }

    
export const getGetExportDownloadQueryOptions = <TData = Awaited<ReturnType<typeof getExportDownload>>, TError = unknown>(params?: GetExportDownloadParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExportDownload>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExportDownloadQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExportDownload>>> = ({ signal }) => getExportDownload(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExportDownload>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExportDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getExportDownload>>>
export type GetExportDownloadQueryError = unknown

export const useGetExportDownload = <TData = Awaited<ReturnType<typeof getExportDownload>>, TError = unknown>(
 params?: GetExportDownloadParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExportDownload>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetExportDownloadQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




